import { useCallback, useEffect, useState } from 'react';
import { notificationsApi } from '../services/api';
import { countUnreadNotifications } from '../utils/countUnreadNotifications';

/** Polls unread notification count for header / sidebar badge. */
export function useUnreadNotificationCount(isCoach: boolean, enabled = true) {
  const [unreadCount, setUnreadCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const res = await notificationsApi.list(!isCoach, 1, true);
      const groups = res.data?.data?.notifications ?? {};
      const total = res.data?.data?.unread_count;
      setUnreadCount(typeof total === 'number' && Number.isFinite(total) ? Math.max(0, total) : countUnreadNotifications(groups));
    } catch {
      // Keep last count on transient network errors.
    }
  }, [isCoach, enabled]);

  const adjustUnreadCount = useCallback((delta: number) => {
    setUnreadCount((count) => Math.max(0, count + delta));
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  useEffect(() => {
    if (!enabled) return;
    const onFocus = () => void refresh();
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [refresh, enabled]);

  useEffect(() => {
    if (!enabled) return;
    const id = window.setInterval(() => void refresh(), 180_000);
    return () => window.clearInterval(id);
  }, [refresh, enabled]);

  return { unreadCount, refresh, adjustUnreadCount };
}
